module.exports = __webpack_public_path__ + "img/les_moissonneuses_1200px.49178c4d.png";